import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { setupAgGrid } from './config/agGridModules';
import { injectResourceHints } from './utils/resourceHints';
import { initWebVitals } from './services/webVitals';
import { Config } from './config/environment';
import './services/adminTenantApi'; // Wire up AdminTenant cache tags
import './services/featureFlagApi'; // Wire up FeatureFlag cache tags
import './services/usersApi'; // Wire up User cache tags
import './services/paymentProcessorApi'; // Wire up PaymentProcessor cache tags
import './services/correctionApi'; // Wire up CorrectionRun cache tags
import './services/whatsNewApi'; // Wire up WhatsNew cache tags
import './services/parentCompanyApi'; // Wire up ParentCompany cache tags
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/900.css';

// Setup AG Grid modules and license before rendering
setupAgGrid();

// Inject resource hints for external resources
injectResourceHints();

// Initialize web vitals monitoring
if (Config.features.enableWebVitals) {
  initWebVitals();
}

// Initialize app services and prefetch data
import('./services/appInitializer');

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);